/**
 * Entrada no painel.
 *
 * Uma tela, um objetivo, um botão — e nada mais. O que ela tem de decisão de desenho é o texto
 * mudar conforme o modo: em demo, dizer **onde os dados ficam** é mais útil que convidar a entrar,
 * porque é a informação que a pessoa não tem e que muda o que ela vai fazer em seguida.
 */

import { useAuth } from '../auth/AuthProvider.js';
import { Button, Notice, RAIO, SOMBRA } from '../components/ui.js';
import { Logo } from '../components/Logo.js';
import { isDemoMode } from '../data/index.js';

export function LoginPage() {
  const { signIn, error } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center px-6">
      <div className={`w-full max-w-sm space-y-6 border border-slate-200 bg-white p-8 ${RAIO.card} ${SOMBRA.card}`}>
        <div className="space-y-3">
          {/* `framed` porque aqui a marca aparece sozinha, como ícone de aplicativo. */}
          <Logo size={48} framed />
          <div className="space-y-1">
            <h1 className="text-2xl font-semibold tracking-tight text-slate-900">OmieChat</h1>
            <p className="text-sm leading-snug text-slate-500">
              {isDemoMode
                ? 'Firebase não configurado: entrando em modo demo, com dados salvos neste navegador.'
                : 'Entre com a conta Google que administra os webchats.'}
            </p>
          </div>
        </div>

        <Button variant="primary" className="w-full" onClick={() => void signIn()}>
          {isDemoMode ? 'Entrar em modo demo' : 'Entrar com Google'}
        </Button>

        {error ? (
          <Notice tone="danger" title="Não foi possível entrar">
            {error}
          </Notice>
        ) : null}
      </div>
    </div>
  );
}
